import Cookies from 'js-cookie'

const BadgeKey = 'Examine-Notice'

export function getLoginBadge(){
    return sessionStorage.getItem(BadgeKey)
}

export function setLoginBadge(){
    return sessionStorage.setItem(BadgeKey, '1')
}

export function removeLoginBadge(){
    return sessionStorage.removeItem(BadgeKey)
}


const LaterKey = 'Later-Notice'

export function getLaterNotice() {
    return Cookies.get(LaterKey)
}

export function setLaterNotice() {
    let now = new Date()
    let expiresDate = new Date(now.getFullYear(), now.getMonth(), now.getDate() + 1)
    return Cookies.set(LaterKey, '1', { expires: expiresDate })
}


// WEBPACK FOOTER //
// ./src/utils/examineNotice.js